import { useMutation } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";

type RepairDossierTransactionsPayload = {
  dossierId: string;
};

export const repairDossierTransactions = (options: APQueryOptions = {}) => {
  const { fetchWithAuth } = useApi();
  const { defaultOnMutateError, defaultOnMutateSettled } = useAPQuery();

  return useMutation({
    mutationFn: (
      payload: RepairDossierTransactionsPayload
    ): Promise<boolean> => {
      return fetchWithAuth<boolean>(
        "repairDossierTransactions",
        payload.dossierId,
        {
          requestOptions: { method: "post", body: JSON.stringify(payload) },
        }
      );
    },
    onError: defaultOnMutateError(options),
    onSuccess: (result: boolean, payload: RepairDossierTransactionsPayload) => {
      const onError = defaultOnMutateError(options);

      if (result) {
        defaultOnMutateSettled([
          ["repairDossierTransactionsStatus", payload.dossierId],
        ]);
      } else {
        onError();
      }
    },
  });
};
